var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="\n<input class=\"form-control\" nv-file-select type=\"file\" multiple=\"multiple\" ng-required=\"to.required\" ng-model=\"model[options.key]\" uploader=\"uploader\"/>\n<div class=\"form-control bssprogressbar-wrapper\">\n<div class=\"bssprogressbar\" ng-if=\"uploading\">\n<center>\n{{percentuale}}%\n</center>\n</div>\n</div>";
var id1="bssfile.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=v1;